import { Search, TrendingUp } from "lucide-react";
import ServizioDetailTemplate from "@/components/servizi/ServizioDetailTemplate";

const SERVIZI = [
  { icon: Search, titolo: "Check-up approfondito", desc: "Valutazione del livello di maturità digitale dell'azienda, individuando processi da ottimizzare, strumenti da introdurre e opportunità legate all'adozione dell'IA." },
  { icon: TrendingUp, titolo: "Indicazioni concrete e percorso di sviluppo", desc: "Forniti a seguito del check-up per migliorare produttività, competitività e capacità di stare al passo con un mercato in continua evoluzione." },
];

export default function CheckUpDigitaleAIPage() {
  return (
    <ServizioDetailTemplate
      testId="check-up-digitale-ai"
      categoriaLabel="Digitale"
      titolo="Check-up Digitale & AI per le PMI"
      heroImage="https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?w=1400&q=80&auto=format"
      heroImageAlt="Laptop con dashboard di analisi dati e intelligenza artificiale"
      leadText="Crescita e sviluppo digitale per affrontare il mondo di oggi e di domani."
      introText="Valutiamo il livello di maturità digitale della tua azienda e ti forniamo indicazioni concrete per migliorare produttività, competitività e capacità di stare al passo con un mercato in continua evoluzione, cogliendo le opportunità offerte dall'intelligenza artificiale."
      servizi={SERVIZI}
      ctaText="Contatta il nostro ufficio per richiedere il tuo check-up digitale e AI."
      telefoni={["06.68437.606", "06.68437.530"]}
    />
  );
}
